import type { LayoutItem } from "react-grid-layout";
import type { ComponentType } from "react";

export type WidgetCategory = "kpi" | "chart" | "table" | "misc";

export interface WidgetMeta {
  id: string;
  title: string;
  description?: string;
  icon?: string;
  category: WidgetCategory;
  minW?: number;
  minH?: number;
  defaultW: number;
  defaultH: number;
  hideHeader?: boolean;
}

export interface WidgetRegistryEntry {
  meta: WidgetMeta;
  component: ComponentType;
}

export interface WidgetPlacement {
  widgetId: string;
  instanceId?: string;
  layout: LayoutItem;
  title?: string;
  hidden?: boolean;
}

export function placementKey(p: WidgetPlacement): string {
  return p.instanceId ?? p.widgetId;
}
